import React from 'react';

const ServicesMarquee = () => (
  <>
    <style>{`
      @keyframes services-marquee {
        0% { transform: translateX(0%); }
        100% { transform: translateX(-50%); }
      }
      .services-marquee-track { display: flex; width: max-content; animation: services-marquee 30s linear infinite; }
      .services-marquee-copy { flex: none; white-space: nowrap; }
      .services-marquee-gradient { background: linear-gradient(to right, #FDE68A 0%, #D4AF37 40%, #B45309 100%); }
    `}</style>
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-7 services-marquee-gradient flex items-center overflow-hidden shadow-sm">
      <div className="services-marquee-track text-[9px] font-bold uppercase tracking-wider text-slate-950 md:text-[10px]">
        {[0, 1].map((copy) => (
          <span className="services-marquee-copy" key={copy}>
            Manpower &amp; Recruitment &bull; Outsourcing &bull; IT Solutions &bull; Skill Upgradation &bull; Travel and Tourism &nbsp; | &nbsp;
            Manpower &amp; Recruitment &bull; Outsourcing &bull; IT Solutions &bull; Skill Upgradation &bull; Travel and Tourism &nbsp; | &nbsp;
            Manpower &amp; Recruitment &bull; Outsourcing &bull; IT Solutions &bull; Skill Upgradation &bull; Travel and Tourism &nbsp; | &nbsp;
          </span>
        ))}
      </div>
    </div>
  </>
);

export default ServicesMarquee;
